import React, { useEffect, useRef, useState } from 'react'
import styles from './PageVisitTracker.module.scss'
import { superAxiosRequest } from 'axiosApi'
import Loader from 'components/UI/Loader/Loader'
import ProfileAvatar from '../ProfileAvatar/ProfileAvatar'
import { ReactComponent as ArrowIcon } from 'components/UI/icons/arrow-down-s-line.svg'
import useLocalization from 'hooks/useLocalization'

const PageVisitTracker = ({ page }) => {
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(true)
  const [showAll, setShowAll] = useState(false)
  const modalRef = useRef(null)
  const buttonRef = useRef(null)
  const isMounted = useRef(true) // Флаг для отслеживания монтирования компонента

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'all_groups',
    dict: {
      working_on_card: 'Working on a card',
    },
  })

  let intervalId = null

  const toggleShowAll = () => {
    setShowAll((prevShowAll) => !prevShowAll)
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setShowAll(false) // Закрытие модального окна при клике вне его и кнопки
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  useEffect(() => {
    // Функция для отправки POST-запроса и обновления списка пользователей
    const markVisit = () => {
      superAxiosRequest(
        {
          link: 'auth/page_visits',
          method: 'post',
          crm: true,
        },
        { page },
      )
        .then(({ data }) => {
          if (isMounted.current) {
            setUsers(data.result)
            setLoading(false)
          }
        })
        .catch((error) => {
          console.error('Error marking visit:', error)
          if (isMounted.current) {
            setLoading(false)
          }
        })
    }

    // Функция для запуска интервала
    const startInterval = () => {
      markVisit() // Выполняем первый запрос сразу
      if (!intervalId) {
        intervalId = setInterval(markVisit, 10000)
      }
    }

    // Функция для остановки интервала
    const stopInterval = () => {
      if (intervalId) {
        clearInterval(intervalId)
        intervalId = null
      }
    }

    // Обработчик события изменения видимости страницы
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        startInterval()
      } else {
        stopInterval()
      }
    }

    // Устанавливаем обработчик события
    document.addEventListener('visibilitychange', handleVisibilityChange)

    // Запускаем интервал при загрузке страницы
    startInterval()

    // Очищаем интервал и удаляем обработчик при размонтировании компонента
    return () => {
      isMounted.current = false // Устанавливаем флаг в false при размонтировании
      stopInterval()
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [page])

  if (loading) {
    return <Loader />
  }

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {translate.working_on_card}: {users.length}
      </div>
      <ul className={styles.userList}>
        {users.slice(0, 3).map((user, index) => (
          <li className={styles.user} key={index}>
            <ProfileAvatar width='18px' height='18px' fs='8px' name={user} />
            {user}
          </li>
        ))}
      </ul>
      {users.length > 3 && (
        <div
          className={styles.showAllButton}
          onClick={toggleShowAll}
          ref={buttonRef}
        >
          show all <ArrowIcon />
        </div>
      )}
      {showAll && (
        <div className={styles.modal} ref={modalRef}>
          <ul className={styles.userListFull}>
            {users.map((user, index) => (
              <li className={styles.userFull} key={index}>
                <ProfileAvatar
                  width='18px'
                  height='18px'
                  fs='8px'
                  name={user}
                />
                {user}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}

export default PageVisitTracker
